export default __webpack_public_path__ + "static/media/4631.18dd2068.png";